import styled from "styled-components";
import { ReactComponent as CloseIcon } from "src/images/taskCloseListIcon.svg";

export const TaskListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export const TaskTitleLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.s};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
  flex: 1;
  text-align: center;
  margin-top: 19px;
  margin-left: 24px;
`;

export const TaskCloseListIcon = styled(CloseIcon)`
  margin-top: 21px;
  justify-self: flex-end;

  :hover {
    cursor: pointer;
  }
`;
